import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import NewsPopup from "../Popup/NewsPopup";
import {
  applySortFilter,
  getComparator,
} from "../../../component/Methods";
import {
  buildSignalWeightsRows,
  SignalWeightsTable,
} from "../components/SignalWeightsTable";

const SignalCurrentList = ({
  strategyValObj,
  strategies,
  strategyVal,
  setPasteButton,
  onCopyClick, // Add this prop
  isLoadingNews,
  setIsLoadingNews,
  hasFetchedNews,
  fetchNewsData,
  newsData,
}) => {
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("value");
  const [newsPopupOpen, setNewsPopupOpen] = useState(false);
  const [selectedNewsData, setSelectedNewsData] = useState([]);
  const [selectedTicker, setSelectedTicker] = useState("");

  useEffect(() => {
    if (strategyValObj && strategies && strategyVal) {
      const strategy = strategies.find(
        (strategy) => strategy.strategyId === strategyValObj
      );

      if (strategy && strategy.signals) {
        const { weights_keys, weights_values } = strategy.signals;
        const combinedArray = buildSignalWeightsRows(
          weights_keys,
          weights_values,
          newsData
        );
        const filteredUsers = applySortFilter(
          combinedArray,
          getComparator(order, orderBy)
        );
        setData(filteredUsers);
      } else {
        setData([]);
      }
    } else {
      setData([]);
    }
  }, [
    strategies,
    strategyValObj,
    strategyVal,
    order,
    orderBy,
    newsData,
  ]);

  useEffect(() => {
    setIsLoadingNews(false);
  }, [strategyValObj]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleNewsClick = (newsItems, ticker) => {
    setSelectedNewsData(newsItems || []);
    setSelectedTicker(ticker);
    setNewsPopupOpen(true);
  };

  const handleNewsPopupClose = () => {
    setNewsPopupOpen(false);
    setSelectedNewsData([]);
    setSelectedTicker("");
  };

  return (
    <>
      <Box
        sx={{
          borderRadius: "4px",
          marginTop: "10px",
          width: "100%",
          marginRight: 1,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          data-testid="current-list-data"
          data-json-data={JSON.stringify(data)}
          style={{ display: "none" }}
        />

        <SignalWeightsTable
          rows={data}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          showNewsColumn
          hasFetchedNews={hasFetchedNews}
          onNewsClick={handleNewsClick}
          tableContainerSx={{
            flex: 1,
            overflowX: "hidden",
            overflowY: "auto",
          }}
        />
      </Box>

      <NewsPopup
        open={newsPopupOpen}
        onClose={handleNewsPopupClose}
        newsData={selectedNewsData}
        ticker={selectedTicker}
      />
    </>
  );
};
export default SignalCurrentList;
